interface Props {
  open: boolean;
}

export const BestHealthLogo = ({ open }: Props) => {
  const imgSrc = open ? "/img/Logo_200x45.png" : "/img/Finch_45x45.png";

  return <img src={imgSrc} alt="logo" height="45px" />;
};
